import type { SupabaseClient } from "@supabase/supabase-js";
import type { Database } from "./persistence/database.generated";
import { SupabaseFileRepository } from "./persistence/supabase/file-repository";
import type { HostedPdfViewPort } from "./hosted-portal-provider";

/** Creates a short-lived signed view grant only after RLS-scoped metadata matches the requested audit. */
export function createHostedPdfViewPort(client:SupabaseClient<Database>):HostedPdfViewPort{
 const files=new SupabaseFileRepository(client);
 return{async createViewGrant({fileId,organisationId,auditEngagementId}){
  const metadata=await files.getMetadata(fileId);
  if(!metadata.ok)return{ok:false,message:metadata.error.message};
  const file=metadata.value;
  if(file.organisationId!==organisationId||file.auditEngagementId!==auditEngagementId)return{ok:false,message:"This PDF is not available in the selected organisation and audit."};
  if(file.bucketId!=="organisation-source-files"||file.mimeType!=="application/pdf"||file.visibility!=="Internal only")return{ok:false,message:"Only the linked private Ayzeo PDF can be opened here."};
  if(file.status!=="Available")return{ok:false,message:"This PDF is not currently available to view."};
  const grant=await files.createDownloadGrant(fileId);
  if(!grant.ok)return{ok:false,message:grant.error.message};
  return{ok:true,url:grant.value.url,expiresAt:grant.value.expiresAt};
 }};
}
